import * as React from 'react';
import { Link } from 'gatsby';
import GatsbyImage from '../../components/gatsby-image';
import SVGImage from "../svg-image/svg-image";
import {TagLine} from "../blog-meta/blog-meta";
import {
  PostListWrapper,
  PostDetails,
  PostTitle,
  PostMeta,
  PostDate,
} from './post-list.style';
import {ThumbnailWrapper} from "../post-details/post-details.style";

interface PostListProps {
  image?: any;
  color?: string;
  title: string;
  url: string;
  date?: string;
  tags?: [];
  className?: string;
}

const PostList: React.FunctionComponent<PostListProps> = ({
  image,
  color,
  title,
  url,
  date,
  tags,
  className,
  ...props
}) => {
  if (image.publicURL.endsWith('.svg')) {
    image = image.publicURL;
  } else {
    image = image.childImageSharp.gatsbyImageData;
  }
  // Add all classs to an array
  const addAllClasses = ['post-list'];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  return (
    <PostListWrapper className={addAllClasses.join(' ')} {...props}>
      <Link to={url}>
        <ThumbnailWrapper>
        {typeof image === 'string' ? (
          <SVGImage
            src={image}
            color={color}
            alt={title}
            iconSize={'80%'}
          />
        ) : (
          <GatsbyImage src={image} alt={title} />
        )}
        </ThumbnailWrapper>
        <PostDetails style={{ width: 0}}>
          <PostTitle className="post-title">{title}</PostTitle>
          <PostMeta>
            {date && (
              <PostDate
                dangerouslySetInnerHTML={{
                  __html: date,
                }}
                className="post-date"
              />
            )}
            {tags == null ? null : (<TagLine tags={tags} max_n_tags={3} can_interact={false} />)}
          </PostMeta>
        </PostDetails>
      </Link>
    </PostListWrapper>
  );
};

export default PostList;
